
import React from "react";
import './section9.css';
import imagemSection5 from '../../assets/mapaOlimpia/MapaFeira6.svg'

const Section9 = () => {
  return (
    <section className="section5">
      <img src={imagemSection5} alt="Descrição da Imagem" className="section9-image" />
    </section>
  );
};

export default Section9;
